import React from "react";
import { useNavigate } from "react-router-dom";
import styles from "./JobCard.module.css";
import { Job } from "../data/jobs";
import CustomButton from "./CustomButton";

interface Props extends Job {
  delay: number;
}

const JobCard: React.FC<Props> = ({ id, title, location, summary, delay }) => {
  const navigate = useNavigate();
  const snippet = summary.length > 200 ? summary.slice(0, 200) + "…" : summary;

  const go = () => navigate(`/jobs/${id}`);

  const onKey: React.KeyboardEventHandler<HTMLDivElement> = (e) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      go();
    }
  };

  const stopBubble: React.MouseEventHandler<HTMLDivElement> = (e) => {
    e.stopPropagation();
  };

  return (
    <div
      className={styles.card}
      style={{ animationDelay: `${delay}ms` }}
      onClick={go}
      onKeyDown={onKey}
      role="link"
      tabIndex={0}
      aria-label={`Stelle öffnen: ${title}`}
    >
      <div className={styles.content}>
        <h3 className={styles.title}>{title}</h3>
        <p className={styles.location}>{location}</p>
        <p className={styles.snippet}>{snippet}</p>
      </div>

      <div onClick={stopBubble}>
        <CustomButton
          text="Mehr erfahren"
          variant="filled"
          size="small"
          onClick={go}
          title={`Zur Stelle: ${title}`}
        />
      </div>
    </div>
  );
};

export default JobCard;
